import AuthNavBar from "./auth-nav-bar.container";

export default AuthNavBar;
